module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/section-1-5811301c7881387d0d93f815c1baccfd.webp";